import { notifySuccess } from "./notify";

export function notifyLabelsCache() {
  return notifySuccess({
    message: "Recalculating Labels",
    caption:
      "It may take a few minutes before new labels are available on report pages",
  });
}
